import React, { FC } from 'react';
import { IBusiness } from '../utils/utils';
import { GetBusinessDetails_getBusiness_possibleSteps } from '../../../graphql/business/types/GetBusinessDetails';
import BusinessEditDatesItem from '../DetailItem/BusinessEditDatesItem';
import CustomAccordion from '../../../common/components/CustomAccordion/CustomAccordion';
import { Grid } from '@material-ui/core';
import BusinessStatusItem from '../DetailItem/BusinessStatusItem';

interface Params {
  businessState: IBusiness;
  setBusinessState: React.Dispatch<React.SetStateAction<IBusiness>>;
  possibleSteps: GetBusinessDetails_getBusiness_possibleSteps[];
  canEditBusiness: boolean;
}

const BusinessStatus: FC<Params> = (props) => {
  const {
    businessState,
    setBusinessState,
    possibleSteps,
    canEditBusiness,
  } = props;

  return (
    <CustomAccordion title="Avancement dossier">
      <Grid container>
        <BusinessEditDatesItem
          editable
          label="Date levée conditions suspensives"
          date={businessState?.unblockedAt}
          onChange={(_date) =>
            setBusinessState((prev) => ({ ...prev, unblockedAt: _date }))
          }
        />
        <BusinessEditDatesItem
          editable
          label="Date prévisionnelle signature notaire"
          date={businessState?.signedByNotaryAt}
          onChange={(_date) =>
            setBusinessState((prev) => ({ ...prev, signedByNotaryAt: _date }))
          }
        />
        <BusinessStatusItem
          isNumber
          mutationVariableName="estimatedMaxPurchase"
          label="Achat max estimé"
          value={businessState?.estimatedMaxPurchase}
          editable={canEditBusiness}
          setBusinessState={setBusinessState}
        />
        <BusinessStatusItem
          isNumber
          mutationVariableName="estimatedMaxLoan"
          label="Emprunt max estimé"
          value={businessState?.estimatedMaxLoan}
          editable={canEditBusiness}
          setBusinessState={setBusinessState}
        />
      </Grid>
    </CustomAccordion>
  );
};

export default BusinessStatus;
